import { Hourglass } from "lucide-react";
import { SubNav, LANGUAGE_SUBNAV, SKILLS_SUBNAV } from "@/components/SubNav";
import { usePrefs } from "@/context/PrefsContext";

const SECTIONS = {
  language: { kicker: "MANABI 言語", title_id: "Modul Bahasa", title_jp: "MANABI 言語", items: LANGUAGE_SUBNAV },
  skills: { kicker: "MANABI 技能", title_id: "Modul Keterampilan", title_jp: "MANABI 技能", items: SKILLS_SUBNAV },
};
const PAGES = {
  english: { section: "language", name_id: "MANABI ENGLISH", name_jp: "MANABI 英語", desc_id: "Modul bahasa Inggris untuk kebutuhan kerja dan komunikasi internasional sedang disiapkan.", desc_jp: "仕事と国際コミュニケーションのための英語教材を準備中です。" },
  caregiver: { section: "skills", name_id: "Caregiver (介護)", name_jp: "介護", desc_id: "Modul keterampilan perawatan lansia (kaigo): istilah kerja, prosedur harian, dan komunikasi dengan pengguna layanan — sedang disiapkan.", desc_jp: "介護の現場で使う用語・日常手順・利用者とのコミュニケーション教材を準備中です。" },
  logistics: { section: "skills", name_id: "Logistic & Warehouse (物流・倉庫)", name_jp: "物流・倉庫", desc_id: "Modul keterampilan logistik & pergudangan: istilah operasional, keselamatan kerja, dan instruksi di lapangan — sedang disiapkan.", desc_jp: "物流・倉庫の業務用語、安全、現場指示の教材を準備中です。" },
  skills: { section: "skills", name_id: "Modul Keterampilan", name_jp: "MANABI 技能", desc_id: "Pilih bidang keterampilan di atas. Semua modul keterampilan akan hadir bertahap.", desc_jp: "上の分野を選んでください。技能教材は順次公開します。" },
};

export default function ComingSoon({ page }) {
  const { lang } = usePrefs();
  const p = PAGES[page];
  const s = SECTIONS[p.section];
  return (
    <div className="fade-up" data-testid={`coming-soon-${page}`}>
      <p className="font-jpserif text-sm tracking-[0.3em] text-muted-foreground">{s.kicker}</p>
      <h1 className="mt-3 font-jpserif text-3xl sm:text-4xl">{lang === "jp" ? s.title_jp : s.title_id}</h1>
      <div className="mt-6"><SubNav items={s.items} testid={`${p.section}-subnav`} /></div>
      <div className="soft-card mt-8 flex flex-col items-start gap-4 p-8 sm:flex-row sm:items-center">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-amber-100 text-amber-800"><Hourglass className="h-6 w-6" /></span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2"><h2 className="text-lg font-semibold" data-testid="coming-soon-title">{lang === "jp" ? p.name_jp : p.name_id}</h2>{page !== "skills" && <span className="rounded-full bg-amber-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-amber-800">Coming soon</span>}</div>
          <p className="mt-2 text-sm text-muted-foreground">{lang === "jp" ? p.desc_jp : p.desc_id}</p>
          <p lang="ja" className="jp mt-1 text-xs text-muted-foreground/70">{lang === "jp" ? p.desc_id : p.desc_jp}</p>
        </div>
      </div>
    </div>
  );
}
